// extracted by mini-css-extract-plugin
export default {"row":"general-tab_row__YgchJ","field":"general-tab_field__EybCC","address":"general-tab_address__nGT+4"};